module.exports = __webpack_public_path__ + "img/Success_Prepared@2x.b04db8cd.png";